/* eslint-disable jsx-a11y/no-distracting-elements */
import "./ChuChay.scss";

function ChuChay() {
  return (
    <section className="notice_bar">
      <div className="notice_box">
        <img src="/icontb.png?v=20262" alt="" />

        <div className="notice">
          <marquee scrollamount="4" scrolldelay="30">

            🎉 ยินดีต้อนรับสู่ QK88BET – สนุกกับกิจกรรมและโปรโมชั่นพิเศษตลอดทั้งปี! 🎉

            🇹🇭 เทศกาลสงกรานต์ – ฉลองปีใหม่ไทย พร้อมกิจกรรมพิเศษและสิทธิประโยชน์มากมาย 💦

            ร่วมสนุกในช่วงเทศกาลสงกรานต์กับ QK88BET พบกับกิจกรรมพิเศษ โบนัส และสิทธิประโยชน์สำหรับสมาชิกตลอดช่วงเทศกาล

            🎊 เทศกาลปีใหม่ – เริ่มต้นปีใหม่ด้วยความสนุกและโปรโมชั่นสุดพิเศษ 🎁

            พบกับกิจกรรมสำหรับสมาชิก โปรโมชั่นพิเศษ และสิทธิประโยชน์มากมายตลอดช่วงเทศกาลปีใหม่

            🪷 เทศกาลลอยกระทง – ร่วมฉลองค่ำคืนแห่งความสุข พร้อมกิจกรรมและโปรโมชั่นพิเศษสำหรับสมาชิก

            ติดตามรายละเอียดกิจกรรมและโปรโมชั่นล่าสุดได้จากหน้าโปรโมชั่นของ QK88BET

            ⭐️ เดิมพันเต็มที่ – รับเงินคืนทันทีสูงสุด 2.5% ⭐️

            สนุกกับการเดิมพัน พร้อมรับสิทธิ์เงินคืนตามเงื่อนไขของโปรโมชั่น โดยไม่ต้องรอถึงวันถัดไป

            ✤ วิธีรับเงินคืน:
            ไปที่เมนู “ของฉัน” ➤ เลือก “รับเงินคืนทันที” ➤ กด “คำนวณเงินคืน” ➤ รับเงินคืนตามยอดที่ระบบแสดง

            🔥 โปรโมชั่น ON CASINO – รับเงินคืนสูงสุด 20% 🔥

            เมื่อเข้าร่วมเดิมพัน BACCARAT ในห้อง ON CASINO และตรงตามเงื่อนไขของกิจกรรม สามารถรับเงินคืนสูงสุด 20% ตามข้อกำหนดของโปรโมชั่น

            💰 โปรโมชั่นฝากเงิน – รับโบนัสสูงสุด 3%

            สมาชิกสามารถเลือกรับโปรโมชั่นที่ร่วมรายการได้จากหน้า “ฝากเงิน” หรือเมนูโปรโมชั่น

            ⮞ วิธีรับโบนัส: เลือก VOUCHER ที่ต้องการก่อนทำรายการฝากเงิน

            กรุณาตรวจสอบรายละเอียด เงื่อนไข และยอดเทิร์นของแต่ละโปรโมชั่นก่อนเข้าร่วม

            🎰🐟 SLOT & เกมยิงปลา – รับโบนัสสูงสุด 10% ตามโปรโมชั่นที่ร่วมรายการ

            พบกับโปรโมชั่นพิเศษสำหรับสมาชิกที่ชื่นชอบ SLOT และเกมยิงปลา พร้อมกิจกรรมและโบนัสตามช่วงเวลาที่กำหนด

            รายละเอียดเพิ่มเติม กรุณาตรวจสอบที่หน้าโปรโมชั่นหรือติดต่อฝ่ายบริการลูกค้าออนไลน์

            ⚠️ ข้อควรระวังในการฝากเงินกับ QK88BET ⚠️

            ✅ กรุณาใช้ข้อมูลการฝากเงินล่าสุดจากเมนู “ฝากเงิน” บนเว็บไซต์ QK88BET เท่านั้น

            ✅ ตรวจสอบชื่อธนาคาร เลขบัญชี จำนวนเงิน และรายละเอียดการโอนให้ถูกต้องก่อนยืนยันทุกครั้ง

            ❌ ห้ามใช้เลขบัญชีธนาคารหรือที่อยู่กระเป๋า USDT จากรายการเก่า เนื่องจากข้อมูลช่องทางการฝากอาจมีการเปลี่ยนแปลง

            ❌ ห้ามโอนเงินตามข้อมูลบัญชีที่ได้รับจากบุคคลภายนอกหรือผู้ที่แอบอ้างเป็นเจ้าหน้าที่

            ⭐️ เพื่อให้ระบบตรวจสอบรายการได้อย่างรวดเร็ว กรุณากรอกข้อมูลการฝากเงินให้ตรงกับรายการโอนจริง

            ⭐️ แนะนำให้ใช้บัญชีธนาคารที่ตรงกับชื่อที่ลงทะเบียนไว้กับสมาชิก

            ⭐️ ตรวจสอบข้อมูลให้ถูกต้องก่อนทำรายการทุกครั้ง

            หากโอนเงินไปยังบัญชีหรือกระเป๋า USDT ที่หมดอายุหรือไม่ได้ใช้งานแล้ว กรุณาติดต่อฝ่ายบริการลูกค้าทันทีเพื่อตรวจสอบรายการ

            ☎️ ฝ่ายบริการลูกค้าออนไลน์พร้อมให้บริการตลอด 24 ชั่วโมง

            ⚽️ สนุกกับฟุตบอลและกิจกรรมกีฬากับ QK88BET ⚽️

            ติดตามการแข่งขันกีฬาคู่สำคัญ พร้อมร่วมกิจกรรมพิเศษสำหรับสมาชิกในช่วงการแข่งขัน

            🎁 ติดตามกิจกรรมและสิทธิประโยชน์เพิ่มเติมได้จากหน้าโปรโมชั่นและประกาศอย่างเป็นทางการของ QK88BET

            💰 โปรแกรมแนะนำเพื่อน – รับสิทธิประโยชน์จากการแนะนำสมาชิก 💰

            แนะนำเพื่อนเข้าร่วม QK88BET และรับสิทธิประโยชน์ตามเงื่อนไขของโปรแกรมแนะนำสมาชิก

            สมาชิกที่คุณแนะนำฝากเงินครั้งแรก ⮞ รับโบนัสตามเงื่อนไขของกิจกรรม

            การฝากเงินครั้งต่อไป ⮞ รับสิทธิประโยชน์ตามโปรโมชั่นที่กำหนด

            รายละเอียดเพิ่มเติม กรุณาไปที่เมนู “ของฉัน” ➤ “แนะนำเพื่อน” หรือติดต่อฝ่ายบริการลูกค้าออนไลน์

            📢 เรียนสมาชิกทุกท่าน

            หากมีคำถามหรือพบปัญหาระหว่างการใช้งาน กรุณาติดต่อฝ่ายบริการลูกค้าออนไลน์ผ่านช่องทางอย่างเป็นทางการของ QK88BET

            ทีมงานพร้อมให้บริการและช่วยเหลือตลอด 24 ชั่วโมง

            🇹🇭 สุขสันต์วันสงกรานต์ 💦
            🪷 สุขสันต์วันลอยกระทง
            🎆 สวัสดีปีใหม่ 🎉

            🍀 QK88BET ขอให้สมาชิกทุกท่านสนุกกับทุกกิจกรรมและโชคดีตลอดทั้งปี!

          </marquee>
        </div>
      </div>
    </section>
  );
}

export default ChuChay;